// extracted by mini-css-extract-plugin
export var checkbox = "_89-0";
export var circle = "_89-3";
export var horizontalContainer = "_89-7";
export var sm = "_89-5";
export var switch0 = "_89-2";
export var switchDisabled = "_89-8";
export var switchEnabled = "_89-1";
export var textSwitchContainer = "_89-9";
export var textSwitchOption = "_89-a";
export var textSwitchOptionSelected = "_89-b";
export var verticalContainer = "_89-6";
export var xs = "_89-4";